<section class="portfolio-area portfolio-area-shape primary-bg section-gap">
    <div class="container">
        <div class="portfolio-top-title mb-60">
            <div class="row align-items-center justify-content-between">
                <div class="col-lg-6 col-md-8">
                    <div class="section-title white-color mb-md-gap-30">
                        <span class="title-tag">Latest Case Studies</span>
                        <h2 class="title">Reads Our Recent Case Studies </h2>
                    </div>
                </div>
                <div class="col-auto">
                    <div class="portfolio-arrow"></div>
                </div>
            </div>
        </div>
        <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="portfolio-items portfolio-slider-one row">
            <!-- Daata -->
            <div ngxSlickItem class="col-lg-12" *ngFor="let item of case">
                <div class="portfolio-item">
                    <div class="portfolio-img">
                        <img [src]="item.img" [alt]="item.title">
                    </div>
                    <div class="portfolio-content">
                        <div class="item">
                            <span class="category" *ngFor="let category of getCategory(item.category) | slice:0:1">{{category.title}}</span>
                            <h5 class="title">{{item.title}}</h5>
                        </div>
                        <a routerLink="/case-details/{{item.id}}" class="portfolio-link"><i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <!-- Data -->
        </ngx-slick-carousel>
    </div>
</section>